import React, { useContext } from 'react';
import './Features.scss';
import { LanguageContext } from '../../context/LanguageContext';
import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const icons = [iconOne, iconTwo, iconThree, iconFour];

const Features = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className="features-section" data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="section-header">
                    <span className="subtitle">{t('features.sectionTitle')}</span>
                    <h2>{t('features.title')}</h2>
                    <p>{t('features.description')}</p>
                </div>
                <div className="row">
                    {t('features.items').map((item, index) => (
                        <div className="col-lg-6 col-md-6" key={index}>
                            <div className="feature-card">
                                <div className="icon-wrapper">
                                    <img src={icons[index]} alt={item.title} className="icon" />
                                </div>
                                <div className="content">
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;